import { render, staticRenderFns } from "./BoardView.vue?vue&type=template&id=d6f058a6"
import script from "./BoardView.vue?vue&type=script&lang=js"
export * from "./BoardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports